<template>
    <li class="list-group-item d-flex justify-content-between align-items-start">
        <div class="ms-2 me-auto">
            <div class="fw-bold">
                <slot></slot>
            </div>
            <em>
                <slot name="subheading"></slot>
            </em>
        </div>
<!--        <span class="badge bg-primary rounded-pill"></span>-->
    </li>
</template>

<script>

export default {
    components: {},

    props: [],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
